import style from "../../../../assets/scss/common/modal/addConsultationModal.module.scss";
import React, {useEffect} from "react";
import {useConsultationGetter} from "../../../sub/consultation/hooks/useConsultationGetter";
import {ConsultationReservation} from "../../../../types/consultation";
import {ReservationSelectTimeOption} from "./ReservationSelectTimeOption";
import {useTranslation} from "react-i18next";

interface Args{
    selectedDate: string;
    setSelectedDate: (_: string) => void;
    selectedTime: string;
    setSelectedTime: (_: string) => void;
    availableTimes: ConsultationReservation[];
    setAvailableTimes: (_: ConsultationReservation[]) => void
    setReservationIdx: (_:number) => void;
}
export function ReservationDateInput(
    {selectedDate, setSelectedDate,
        selectedTime, setSelectedTime,
        availableTimes, setAvailableTimes,
        setReservationIdx}:Args) {
    /**
     * 상담 정보 확인
     * 상담 예약 일자 영역
     */
    const { t } = useTranslation("consultant");
    const {getAvailableReservation, reservationList} = useConsultationGetter();

    useEffect(() => {
        setAvailableTimes(reservationList)
        setSelectedTime("")
        // eslint-disable-next-line
    }, [reservationList]);

    // 날짜 예약
    const handleDateChange = (event: any) => {
        setSelectedDate(event.target.value);
        setSelectedTime("")
        setReservationIdx(0)
        getAvailableReservation({desiredDate:event.target.value}).then();
    };


    // 시간예약 & 예약 idx 저장
    const handleTimeSelection = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOption = event.target.selectedOptions[0];
        const selectedTime = selectedOption.value;
        const selectedIdx = Number(selectedOption.dataset.idx);

        setSelectedTime(selectedTime);
        setReservationIdx(selectedIdx);
    };

    // 신청 최소 가능일 (오늘 날짜 + 3)
    const getMinDate = () => {
        const today = new Date();
        const minDate = new Date(today);
        minDate.setDate(today.getDate() + 3);
        return minDate.toISOString().split('T')[0];
    };

    return (
        <>
            <div className={style.innerTextContainer}>
                <div className={style.infoContainer}>
                    <span className={style.infoTitleText}> {t('detail.modal.info.title')}</span>
                    <span className={style.innerTextDesc}>
                {t('detail.modal.info.desc1')} <br/>
                {t('detail.modal.info.desc2')}<br/>
                {t('detail.modal.info.desc3')} <br/>
                {t('detail.modal.info.desc4')} <br/>
                {t('detail.modal.info.desc5')}
                <br/>
              </span>

                    <div className={style.consultInputContainer}>
                        <span className={style.consultInputTitle}>{t('detail.modal.wishDate')}</span>
                        <input
                            onChange={handleDateChange}
                            type="date"
                            id="date-picker"
                            className={style.customDateInput}
                            min={getMinDate()} // 오늘 날짜 기준 + 3일
                            value={selectedDate}
                        />
                    </div>
                    <div className={style.consultInputContainer}>
                        <span className={style.consultInputTitle}>{t('detail.modal.wishTime')}</span>

                        <select
                            className={style.customDateInput}
                            value={selectedTime}
                            onChange={handleTimeSelection}
                        >
                            {selectedTime==="" && (
                                <option value="" disabled hidden>
                                    {t('detail.modal.defaultTime')}
                                </option>
                            )}
                            <ReservationSelectTimeOption
                                reservations={availableTimes}
                                onTimeSelect={(time, idx) => {
                                    setSelectedTime(time);
                                    setReservationIdx(idx);
                                }}
                            />
                        </select>

                    </div>
                </div>
            </div>
        </>
    )
}